import React from "react";
import { useState, useEffect } from "react";
import "../style/profilePage.css";

const SidebarMenu = (props) => {
  const [page, setPage] = useState("1");

  useEffect(() => {
    const idArray = ["initial-setup", "avalable-times", "advance-setup"];

    for (let i = 0; i < idArray.length; i++) {
      let id = idArray[i];
      if (document.getElementById(id).classList.contains("choosed"))
        document.getElementById(id).classList.remove("choosed");
    }

    if (page == 1)
      document.getElementById("initial-setup").classList.add("choosed");

    if (page == 2)
      document.getElementById("avalable-times").classList.add("choosed");

    if (page == 3)
      document.getElementById("advance-setup").classList.add("choosed");

    props.pageFiller(page);
  }, [page]);

  return (
    <div className="side-bar-card">
      <div className="box" onClick={() => setPage("1")} id="initial-setup">
        <img className="sidebar-icon" src="user.png"></img>
        <div className="mytext">مشخصات کاربری</div>
      </div>

      <div className="box" onClick={() => setPage("2")} id="avalable-times">
        <img className="sidebar-icon" src="reset-password.png"></img>
        <div className="mytext">تغییر رمز عبور</div>
      </div>

      <div className="box" onClick={() => setPage("3")} id="advance-setup">
        <img className="sidebar-icon" src="log-out.png"></img>
        <div className="mytext">خروج</div>
      </div>
    </div>
  );
};

export default SidebarMenu;
